
import { Module, Payload, ActionContext } from 'vuex';
import { RootStoreState } from '@/store';
import ApiServiceWrapper from '@/shared/api-request.service';

export interface SwQsgStoreState {
  qsgDisplayStatus: Boolean;
  openDropdownLight: Boolean;
}

/** payloads */
export interface OpenQsgPayload extends Partial<Payload> {
  flag: boolean;
}
export interface OpenDropdownLightPayload extends Partial<Payload> {
  flag: boolean;
}

/** mutations and actions */
export const MUTATION_OPEN_QSG = 'openQsg';
export const MUTATION_OPEN_DROPDOWN_LIGHT = 'openDropdownLight';

export default {
  namespaced: true,
  state: {
    qsgDisplayStatus: false,
    openDropdownLight: false,
  },
  /* tslint:disable:function-name */
  getters: {
  },
  mutations: {
    [MUTATION_OPEN_QSG](state, payload: OpenQsgPayload) {
      if (payload.flag) {
        state.qsgDisplayStatus = !state.qsgDisplayStatus;
      }
    },
    [MUTATION_OPEN_DROPDOWN_LIGHT](state, payload: OpenDropdownLightPayload) {
      if (payload.flag) {
        state.openDropdownLight = true;
      } else {
        state.openDropdownLight = false;
      }
    },
    /*
    [MUTATION_OPEN_DROPDOWN_LIGHT](state, payload: OpenDropdownLightPayload) {
      if (payload.flag) {
        state.openDropdownLight = !state.openDropdownLight;
      }
    },
    */
  },
  actions: {
    postDisableQsg(context: ActionContext<SwQsgStoreState, RootStoreState>, requestBody: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/enable-disable-highlighter';
      return ApiServiceWrapper.post(endpoint, requestBody);
    },
  },
  /* tslint:enable:function-name */
} as Module<SwQsgStoreState, RootStoreState>;
